import Box from "@mui/material/Box";
import { styled, useTheme } from "@mui/material/styles";
import type { ReactElement } from "react";
import { ProposalMove } from "work/proposals/__constants/proposal-lifecycle";
import { proposalTableContextOfMove } from "work/proposals/_views/proposal-table-context";
import {
  getProposalTableContextSwatch,
  proposalTableContextStyleConfig,
} from "work/proposals/_views/proposal-table-context-style";
import { MOVE_PARAMETER } from "work/proposals/_views/proposals-page-tabs";

const Swatch = styled(Box)(() => ({
  border: "1px solid",
  borderRadius: 3,
  flexShrink: 0,
  height: 12,
  width: 12,
}));

/**
 * The tint of the rows a move chip lists, drawn at the start of the chip, so the move chips double
 * as the table's legend (#6473).
 *
 * Decorative: the chip's label says what it lists. Without `aria-hidden` the swatch's title became
 * the start of the chip's name ("No action needed Their move").
 */
export function ProposalMoveSwatch(props: Readonly<{ move: ProposalMove; className?: string }>) {
  const theme = useTheme();
  const context = proposalTableContextOfMove(props.move);
  return (
    <Swatch
      // A chip hands its icon the class that places it; without it the swatch sat on the chip's edge.
      className={props.className}
      aria-hidden
      data-testid={`move-swatch-${props.move}`}
      title={proposalTableContextStyleConfig[context].label}
      sx={getProposalTableContextSwatch(theme, context)}
    />
  );
}

/** A Proposals chip's own icon, for `ListChips`: the move chips' swatch, and nothing for the others. */
export function proposalChipIcon(parameter: string, value: string): ReactElement | undefined {
  if (parameter !== MOVE_PARAMETER) return undefined;
  return <ProposalMoveSwatch move={value as ProposalMove} />;
}
